import React, { useState, useEffect } from "react";
import { Popover } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import "./TitleTooltip.scss";

type Props = {
    content: string;
};

function TitleTooltip({ content }: Props) {
    return (
        <span className="opt-title-tooltip" style={{ cursor: "pointer", fontSize: "15px" }}>
            <Popover
                trigger="hover"
                placement={"top"}
                content={
                    <span style={{ display: "block", fontSize: "15px", maxWidth: "300px" }}>
                        {content}
                    </span>
                }
            >
                {/*@ts-ignore */}
                <FontAwesomeIcon style={{ fontSize: "10px" }} icon={faQuestionCircle} />
            </Popover>
        </span>
    );
}
export default TitleTooltip;
